module.exports = __webpack_public_path__ + "static/media/lenciso3.1ee73189.jpg";